import React from "react";
import { useFetch } from "../../hooks/useFetch";

interface LegalDocProps {
  fileName: string;
  documentType: string;
}

const LegalDoc: React.FC<LegalDocProps> = ({ fileName, documentType }) => {
  const { data: document } = useFetch(async () => {
    const response = await fetch(`${process.env.PUBLIC_URL}/${fileName}`);
    return response.text();
  }, [fileName]);

  const formatDocument = (text: string) => {
    const lines = text.split("\n");
    const elements: React.ReactElement[] = [];

    lines.forEach((line, index) => {
      if (index === 0) return;

      // numbered section heading ("1. INTRODUCTION")
      const sectionMatch = line.match(/^(\d+)\.\s+([A-Z\s]+)$/);
      if (sectionMatch) {
        elements.push(
          <h2
            key={index}
            className="text-base font-semibold text-white mt-10 mb-3 first:mt-0"
          >
            {sectionMatch[1]}. {sectionMatch[2]}
          </h2>,
        );
      }
      // subheadings (ending with colon)
      else if (line.trim().endsWith(":") && line.trim().length < 50) {
        elements.push(
          <h3
            key={index}
            className="text-sm font-semibold text-white/80 mt-5 mb-2"
          >
            {line.trim()}
          </h3>,
        );
      }
      // regular paragraph text
      else if (line.trim().length > 0) {
        elements.push(
          <p key={index} className="text-white/50 text-sm leading-relaxed mb-3">
            {line}
          </p>,
        );
      }
      // empty lines for spacing
      else {
        elements.push(<div key={index} className="h-2" />);
      }
    });

    return elements;
  };

  return (
    <main className="bg-dark-bg min-h-screen px-5 py-0">
      <div className="container mx-auto w-full max-w-3xl">
        {/* Header */}
        <div className="pt-20">
          <h1 className="text-5xl md:text-[3.5rem] leading-none font-semibold">
            <span className="bg-gradient-text bg-clip-text text-transparent">
              {documentType}
            </span>
          </h1>
          <p className="mt-4 text-white/40 text-sm">Data Revival</p>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mt-10 mb-10" />

        {/* Content */}
        <div className="pb-24">{formatDocument(document ?? "")}</div>
      </div>
    </main>
  );
};

export default LegalDoc;
